var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], {"dev":false,"autoescape":true,"throwOnUndefined":false,"trimBlocks":false,"lstripBlocks":false});
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["@templates/components/molecules/favoriteButton.html.njk"] = require( "@templates/components/molecules/favoriteButton.html.njk" );
dependencies["@templates/components/molecules/house-feature-list.html.njk"] = require( "@templates/components/molecules/house-feature-list.html.njk" );
dependencies["@templates/components/organisms/card-house__instant-booking.html.njk"] = require( "@templates/components/organisms/card-house__instant-booking.html.njk" );
dependencies["@templates/components/organisms/card-house-extra-costs-info-button.macro.njk"] = require( "@templates/components/organisms/card-house-extra-costs-info-button.macro.njk" );
dependencies["@naturehouse/design-system/components/atoms/tool-tip/ToolTip.macro.njk"] = require( "@naturehouse/design-system/components/atoms/tool-tip/ToolTip.macro.njk" );
dependencies["@naturehouse/design-system/components/molecules/carousel/simple-carousel/SimpleCarousel.macro.njk"] = require( "@naturehouse/design-system/components/molecules/carousel/simple-carousel/SimpleCarousel.macro.njk" );
dependencies["@naturehouse/design-system/components/atoms/rating/Rating.macro.njk"] = require( "@naturehouse/design-system/components/atoms/rating/Rating.macro.njk" );




var shim = require("/builds/natuurhuisje/nature.house/symfony/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["templates/components/organisms/card-house.html.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("@templates/components/molecules/favoriteButton.html.njk", false, "templates/components/organisms/card-house.html.njk", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("favoriteButton", t_1);
output += "\n";
env.getTemplate("@templates/components/molecules/house-feature-list.html.njk", false, "templates/components/organisms/card-house.html.njk", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
context.setVariable("houseFeatureList", t_4);
output += "\n";
env.getTemplate("@templates/components/organisms/card-house__instant-booking.html.njk", false, "templates/components/organisms/card-house.html.njk", false, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
context.setVariable("instantBookingTemplate", t_7);
output += "\n";
env.getTemplate("@templates/components/organisms/card-house-extra-costs-info-button.macro.njk", false, "templates/components/organisms/card-house.html.njk", false, function(t_11,t_10) {
if(t_11) { cb(t_11); return; }
t_10.getExported(function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
context.setVariable("cardHouseExtraCostsInfoButton", t_10);
output += "\n";
env.getTemplate("@naturehouse/design-system/components/atoms/tool-tip/ToolTip.macro.njk", false, "templates/components/organisms/card-house.html.njk", false, function(t_14,t_13) {
if(t_14) { cb(t_14); return; }
t_13.getExported(function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
context.setVariable("toolTip", t_13);
output += "\n";
env.getTemplate("@naturehouse/design-system/components/molecules/carousel/simple-carousel/SimpleCarousel.macro.njk", false, "templates/components/organisms/card-house.html.njk", false, function(t_17,t_16) {
if(t_17) { cb(t_17); return; }
t_16.getExported(function(t_18,t_16) {
if(t_18) { cb(t_18); return; }
context.setVariable("imageCarousel", t_16);
output += "\n\n";
var t_19;
t_19 = env.getTest("defined").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")) === true && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price"));
frame.set("has_price", t_19, true);
if(frame.topLevel) {
context.setVariable("has_price", t_19);
}
if(frame.topLevel) {
context.addExport("has_price", t_19);
}
output += "\n";
var t_20;
t_20 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"totalWithDiscount");
frame.set("has_lastminute_price", t_20, true);
if(frame.topLevel) {
context.setVariable("has_lastminute_price", t_20);
}
if(frame.topLevel) {
context.addExport("has_lastminute_price", t_20);
}
output += "\n\n";
if(!env.getTest("defined").call(context, runtime.contextOrFrameLookup(context, frame, "compact")) === true) {
output += "\n    ";
var t_21;
t_21 = false;
frame.set("compact", t_21, true);
if(frame.topLevel) {
context.setVariable("compact", t_21);
}
if(frame.topLevel) {
context.addExport("compact", t_21);
}
output += "\n";
;
}
output += "\n\n";
var t_22;
t_22 = env.getTest("defined").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"images")) === true && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"images")) > 1;
frame.set("showCarousel", t_22, true);
if(frame.topLevel) {
context.setVariable("showCarousel", t_22);
}
if(frame.topLevel) {
context.addExport("showCarousel", t_22);
}
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "showCarousel")) {
output += "\n    ";
var t_23;
t_23 = [];
frame.set("slides", t_23, true);
if(frame.topLevel) {
context.setVariable("slides", t_23);
}
if(frame.topLevel) {
context.addExport("slides", t_23);
}
output += "\n    ";
frame = frame.push();
var t_26 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"images");
if(t_26) {t_26 = runtime.fromIterator(t_26);
var t_25 = t_26.length;
for(var t_24=0; t_24 < t_26.length; t_24++) {
var t_27 = t_26[t_24];
frame.set("image", t_27);
frame.set("loop.index", t_24 + 1);
frame.set("loop.index0", t_24);
frame.set("loop.revindex", t_25 - t_24);
frame.set("loop.revindex0", t_25 - t_24 - 1);
frame.set("loop.first", t_24 === 0);
frame.set("loop.last", t_24 === t_25 - 1);
frame.set("loop.length", t_25);
output += "\n        ";
var t_28;
t_28 = [{"width": 295,"height": 221},{"width": 335,"height": 251},{"width": 390,"height": 293},{"width": 430,"height": 322},{"width": 560,"height": 420},{"width": 590,"height": 442}];
frame.set("sizes", t_28, true);
if(frame.topLevel) {
context.setVariable("sizes", t_28);
}
if(frame.topLevel) {
context.addExport("sizes", t_28);
}
output += "\n\n        ";
var t_29;
t_29 = "";
frame.set("srcset", t_29, true);
if(frame.topLevel) {
context.setVariable("srcset", t_29);
}
if(frame.topLevel) {
context.addExport("srcset", t_29);
}
output += "\n        ";
frame = frame.push();
var t_32 = runtime.contextOrFrameLookup(context, frame, "sizes");
if(t_32) {t_32 = runtime.fromIterator(t_32);
var t_31 = t_32.length;
for(var t_30=0; t_30 < t_32.length; t_30++) {
var t_33 = t_32[t_30];
frame.set("size", t_33);
frame.set("loop.index", t_30 + 1);
frame.set("loop.index0", t_30);
frame.set("loop.revindex", t_31 - t_30);
frame.set("loop.revindex0", t_31 - t_30 - 1);
frame.set("loop.first", t_30 === 0);
frame.set("loop.last", t_30 === t_31 - 1);
frame.set("loop.length", t_31);
output += "\n            ";
var t_34;
t_34 = runtime.contextOrFrameLookup(context, frame, "srcset") + "" + t_27 + "" + ",fit=cover,width=" + "" + runtime.memberLookup((t_33),"width") + "" + ",height=" + "" + runtime.memberLookup((t_33),"height") + "" + " " + "" + runtime.memberLookup((t_33),"width") + "" + "w,";
frame.set("srcset", t_34, true);
if(frame.topLevel) {
context.setVariable("srcset", t_34);
}
if(frame.topLevel) {
context.addExport("srcset", t_34);
}
output += "\n        ";
;
}
}
frame = frame.pop();
output += "\n        ";
var t_35;
t_35 = env.getFilter("trim").call(context, runtime.contextOrFrameLookup(context, frame, "srcset"),",");
frame.set("srcset", t_35, true);
if(frame.topLevel) {
context.setVariable("srcset", t_35);
}
if(frame.topLevel) {
context.addExport("srcset", t_35);
}
output += "\n\n        ";
var t_36;
t_36 = env.getFilter("merge").call(context, runtime.contextOrFrameLookup(context, frame, "slides"),[{"src": t_27 + "" + ",fit=cover,width=28,height=21","srcset": runtime.contextOrFrameLookup(context, frame, "srcset"),"sizes": "\n                (max-width: 767px) calc(100vw - 2.5rem),\n                (max-width: 1023px) calc(33vw - 2.5rem),\n                (max-width: 1279px) calc(21.67vw - 2.5rem),\n                295px","alt": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"title"),"loading": "lazy"}]);
frame.set("slides", t_36, true);
if(frame.topLevel) {
context.setVariable("slides", t_36);
}
if(frame.topLevel) {
context.addExport("slides", t_36);
}
output += "\n    ";
;
}
}
frame = frame.pop();
output += "\n";
;
}
output += "\n\n<article class=\"card card--horizontal card--house-search\" data-house-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"id"), env.opts.autoescape);
output += "\">\n    <header class=\"card__header\">\n        <a class=\"card--anchor\" href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"websiteUrl"), env.opts.autoescape);
output += "\" target=\"_blank\" data-role=\"open-house-detail\">\n            <div class=\"card__image-container\">\n                ";
if(runtime.contextOrFrameLookup(context, frame, "showCarousel")) {
output += "\n                    ";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 53, colno = 43, runtime.callWrap(runtime.memberLookup((t_16),"render"), "imageCarousel[\"render\"]", context, [{"slides": runtime.contextOrFrameLookup(context, frame, "slides"),"loading": env.getFilter("default").call(context, runtime.contextOrFrameLookup(context, frame, "loading"),"eager")}]))), env.opts.autoescape);
output += "\n                ";
;
}
else {
output += "\n                    <img\n                        src=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"imageUrl") + "" + ",fit=cover,width=280,height=210", env.opts.autoescape);
output += "\"\n                        srcset=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"imageUrl") + "" + ",fit=cover,width=295,height=221", env.opts.autoescape);
output += " 295w,\n                                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"imageUrl") + "" + ",fit=cover,width=335,height=251", env.opts.autoescape);
output += " 335w,\n                                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"imageUrl") + "" + ",fit=cover,width=390,height=293", env.opts.autoescape);
output += " 390w,\n                                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"imageUrl") + "" + ",fit=cover,width=430,height=322", env.opts.autoescape);
output += " 430w,\n                                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"imageUrl") + "" + ",fit=cover,width=560,height=420", env.opts.autoescape);
output += " 560w,\n                                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"imageUrl") + "" + ",fit=cover,width=590,height=442", env.opts.autoescape);
output += " 590w,\n                                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"imageUrl") + "" + ",fit=cover,width=670,height=502", env.opts.autoescape);
output += " 670w,\n                                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"imageUrl") + "" + ",fit=cover,width=780,height=585", env.opts.autoescape);
output += " 780w,\n                                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"imageUrl") + "" + ",fit=cover,width=860,height=644", env.opts.autoescape);
output += " 860w,\n                                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"imageUrl") + "" + ",fit=cover,width=1170,height=877", env.opts.autoescape);
output += " 1170w\"\n                        sizes=\"(max-width: 767px) calc(100vw - 2.5rem),\n                            (max-width: 1023px) calc(33vw - 2.5rem),\n                            (max-width: 1279px) calc(21.67vw - 2.5rem),\n                            295px\"\n                        alt=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"title"), env.opts.autoescape);
output += "\"\n                        class=\"card__image\"\n                        loading=\"lazy\"\n                        width=\"280\"\n                        height=\"210\"\n                    >\n                ";
;
}
output += "\n            </div>\n        </a>\n\n        ";
output += runtime.suppressValue((lineno = 84, colno = 32, runtime.callWrap(runtime.memberLookup((t_1),"render"), "favoriteButton[\"render\"]", context, [runtime.contextOrFrameLookup(context, frame, "house"),env.getFilter("default").call(context, runtime.contextOrFrameLookup(context, frame, "is_favorite"),false)])), env.opts.autoescape);
output += "\n\n        ";
if(runtime.contextOrFrameLookup(context, frame, "has_lastminute_price")) {
output += "\n            <span data-tool-tip=\"lastminute-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"id"), env.opts.autoescape);
output += "\"\n                  class=\"nh-tag nh-tag--action nh-tag--accent house__label house__label--absolute\">\n                ";
output += runtime.suppressValue(env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"lastMinuteLabel")), env.opts.autoescape);
output += "\n            </span>\n            ";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 94, colno = 29, runtime.callWrap(runtime.memberLookup((t_13),"render"), "toolTip[\"render\"]", context, [{"id": "lastminute-" + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"id"),"placement": "top","content": env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"lastMinuteContent"))}]))), env.opts.autoescape);
output += "\n        ";
;
}
output += "\n    </header>\n\n    <div class=\"card__content\">\n        <header class=\"card__content__header\">\n            <div class=\"card__content__header-title\">\n                <div>\n                    <span class=\"card__title\">\n                        <a data-role=\"open-house-detail\" href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"websiteUrl"), env.opts.autoescape);
output += "\" target=\"_blank\">\n                            ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"title"), env.opts.autoescape);
output += "\n                        </a>\n                    </span>\n                    <span class=\"card__subtitle\">\n                        ";
if(env.getTest("defined").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"locationTitle")) === true) {
output += "\n                            ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"locationTitle"), env.opts.autoescape);
output += "\n                        ";
;
}
else {
output += "\n                            ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"subtitle"), env.opts.autoescape);
output += "\n                        ";
;
}
output += "\n                    </span>\n                </div>\n\n                ";
if(env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"natureRating"),0) > 0 && env.getFilter("default").call(context, runtime.contextOrFrameLookup(context, frame, "compact"),false) == false) {
output += "\n                    <div class=\"nh-rating-container\">\n                        ";
env.getTemplate("@naturehouse/design-system/components/atoms/rating/Rating.macro.njk", false, "templates/components/organisms/card-house.html.njk", false, function(t_38,t_37) {
if(t_38) { cb(t_38); return; }
t_37.getExported(function(t_39,t_37) {
if(t_39) { cb(t_39); return; }
context.setVariable("ratingTemplate", t_37);
output += "\n                        ";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 123, colno = 48, runtime.callWrap(runtime.memberLookup((t_37),"render"), "ratingTemplate[\"render\"]", context, [{"variant": "nature","value": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"natureRating")}]))), env.opts.autoescape);
output += "\n                    </div>\n                ";
})});
}
output += "\n            </div>\n\n            ";
output += runtime.suppressValue((lineno = 131, colno = 38, runtime.callWrap(runtime.memberLookup((t_4),"render"), "houseFeatureList[\"render\"]", context, [runtime.contextOrFrameLookup(context, frame, "house"),runtime.contextOrFrameLookup(context, frame, "translations")])), env.opts.autoescape);
output += "\n        </header>\n\n        <footer class=\"card__content__footer\">\n            <div class=\"card__content__footer__pricing\" data-section=\"pricing\">\n                ";
if(runtime.contextOrFrameLookup(context, frame, "has_price")) {
output += "\n                    ";
if(!runtime.contextOrFrameLookup(context, frame, "compact")) {
output += "\n                        ";
if(runtime.contextOrFrameLookup(context, frame, "isSearchLowestPriceVariantActive")) {
output += "\n                            <div class=\"card__content__footer__date--lowest-price\">\n                                <div>\n                                    <span>\n                                        ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "arrivalDate"), env.opts.autoescape);
output += " - ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "departureDate"), env.opts.autoescape);
output += "\n                                    </span>\n                                    <span class=\"card__content__footer__date--separator\">•</span>\n                                    <span>\n                                        ";
var t_40;
t_40 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"totalWithDiscount");
frame.set("totalWithDiscount", t_40, true);
if(frame.topLevel) {
context.setVariable("totalWithDiscount", t_40);
}
if(frame.topLevel) {
context.addExport("totalWithDiscount", t_40);
}
output += "\n                                        ";
if(!runtime.contextOrFrameLookup(context, frame, "totalWithDiscount")) {
output += "\n                                            ";
var t_41;
t_41 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"total");
frame.set("totalWithDiscount", t_41, true);
if(frame.topLevel) {
context.setVariable("totalWithDiscount", t_41);
}
if(frame.topLevel) {
context.addExport("totalWithDiscount", t_41);
}
output += "\n                                        ";
;
}
output += "\n                                    </span>\n                                </div>\n                                <div>\n                                    ";
output += runtime.suppressValue(env.getFilter("format_currency").call(context, runtime.contextOrFrameLookup(context, frame, "totalWithDiscount"),"EUR"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(env.getFilter("lower").call(context, env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"total"))), env.opts.autoescape);
output += "\n                                </div>\n                            </div>\n                        ";
;
}
output += "\n                        ";
if(!runtime.contextOrFrameLookup(context, frame, "isSearchLowestPriceVariantActive")) {
output += "\n                            <div class=\"card__content__footer__date\">\n                                <div>\n                                    <span>\n                                        ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "arrivalDate"), env.opts.autoescape);
output += " - ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "departureDate"), env.opts.autoescape);
output += "\n                                    </span>\n                                    <span class=\"card__content__footer__date--separator\">•</span>\n                                </div>\n                                <data\n                                    class=\"search__result__total-price\"\n                                    value=\"";
output += runtime.suppressValue(env.getFilter("default").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"totalWithDiscount"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"total")), env.opts.autoescape);
output += "\"\n                                    data-testid=\"house-card-total-price\"\n                                >\n                                    ";
var t_42;
t_42 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"totalWithDiscount");
frame.set("totalWithDiscount", t_42, true);
if(frame.topLevel) {
context.setVariable("totalWithDiscount", t_42);
}
if(frame.topLevel) {
context.addExport("totalWithDiscount", t_42);
}
output += "\n                                    ";
if(!runtime.contextOrFrameLookup(context, frame, "totalWithDiscount")) {
output += "\n                                        ";
var t_43;
t_43 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"total");
frame.set("totalWithDiscount", t_43, true);
if(frame.topLevel) {
context.setVariable("totalWithDiscount", t_43);
}
if(frame.topLevel) {
context.addExport("totalWithDiscount", t_43);
}
output += "\n                                    ";
;
}
output += "\n                                    ";
output += runtime.suppressValue(env.getFilter("format_currency").call(context, runtime.contextOrFrameLookup(context, frame, "totalWithDiscount"),"EUR"), env.opts.autoescape);
output += "\n                                </data>\n                            </div>\n                        ";
;
}
output += "\n                    ";
;
}
output += "\n\n                    ";
var t_44;
t_44 = ["search__result__price--container"];
frame.set("priceContainerClasses", t_44, true);
if(frame.topLevel) {
context.setVariable("priceContainerClasses", t_44);
}
if(frame.topLevel) {
context.addExport("priceContainerClasses", t_44);
}
output += "\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "compact") == true) {
output += "\n                        ";
var t_45;
t_45 = env.getFilter("merge").call(context, runtime.contextOrFrameLookup(context, frame, "priceContainerClasses"),["search__result__price--container__compact"]);
frame.set("priceContainerClasses", t_45, true);
if(frame.topLevel) {
context.setVariable("priceContainerClasses", t_45);
}
if(frame.topLevel) {
context.addExport("priceContainerClasses", t_45);
}
output += "\n                    ";
;
}
output += "\n\n                    ";
if(env.getTest("defined").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")) === true) {
output += "\n                        <div class=\"";
output += runtime.suppressValue(env.getFilter("join").call(context, runtime.contextOrFrameLookup(context, frame, "priceContainerClasses")," "), env.opts.autoescape);
output += "\">\n                            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"dayPriceWithDiscount")) {
output += "\n                                <div class=\"search__result__price-discount\">\n                                    <div class=\"search__result__per-night-label\">\n                                        ";
if(!runtime.contextOrFrameLookup(context, frame, "userHasPeriodSelected") && runtime.contextOrFrameLookup(context, frame, "isSearchLowestPriceVariantActive")) {
output += "\n                                            ";
output += runtime.suppressValue(env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"perNightFrom")), env.opts.autoescape);
output += "\n                                        ";
;
}
else {
output += "\n                                            ";
output += runtime.suppressValue(env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"perNight")), env.opts.autoescape);
output += "\n                                        ";
;
}
output += "\n                                    </div>\n                                    <data class=\"search__result__day-price_discount\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"dayPrice"), env.opts.autoescape);
output += "\">\n                                        ";
output += runtime.suppressValue(env.getFilter("format_currency").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"dayPrice"),"EUR"), env.opts.autoescape);
output += "\n                                    </data>\n                                </div>\n                                <div class=\"search__result__price\">\n                                    ";
if(runtime.inOperator("instantBooking",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"features"))) {
output += "\n                                        ";
var t_46;
t_46 = (function() {
var output = "";
output += "\n                                            ";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 203, colno = 61, runtime.callWrap(runtime.memberLookup((t_13),"render"), "toolTip[\"render\"]", context, [{"id": "instant-booking-" + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"id"),"placement": "top","content": env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"instantBooking"))}]))), env.opts.autoescape);
output += "\n                                        ";
;
return output;
})()
;
frame.set("instantBookingTooltip", t_46, true);
if(frame.topLevel) {
context.setVariable("instantBookingTooltip", t_46);
}
if(frame.topLevel) {
context.addExport("instantBookingTooltip", t_46);
}
output += "\n                                        ";
output += runtime.suppressValue((lineno = 209, colno = 72, runtime.callWrap(runtime.memberLookup((t_7),"render"), "instantBookingTemplate[\"render\"]", context, [runtime.contextOrFrameLookup(context, frame, "instantBookingTooltip"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"id")])), env.opts.autoescape);
output += "\n                                    ";
;
}
output += "\n\n                                    <data\n                                        class=\"search__result__day-price search__result__day-price--discount\"\n                                        value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"dayPriceWithDiscount"), env.opts.autoescape);
output += "\"\n                                    >\n                                        ";
output += runtime.suppressValue(env.getFilter("format_currency").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"dayPriceWithDiscount"),"EUR"), env.opts.autoescape);
output += "\n                                    </data>\n                                    <div class=\"search__result__info\">\n                                        ";
var t_47;
t_47 = "extra-cost-template-" + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"id");
frame.set("template_id", t_47, true);
if(frame.topLevel) {
context.setVariable("template_id", t_47);
}
if(frame.topLevel) {
context.addExport("template_id", t_47);
}
output += "\n                                        ";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 220, colno = 79, runtime.callWrap(runtime.memberLookup((t_10),"render"), "cardHouseExtraCostsInfoButton[\"render\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"id"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"startDate"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"endDate")]))), env.opts.autoescape);
output += "\n                                    </div>\n                                </div>\n                            ";
;
}
else {
output += "\n                                <div class=\"search__result__per-night-label\">\n                                    ";
if(!runtime.contextOrFrameLookup(context, frame, "userHasPeriodSelected") && runtime.contextOrFrameLookup(context, frame, "isSearchLowestPriceVariantActive")) {
output += "\n                                        ";
output += runtime.suppressValue(env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"perNightFrom")), env.opts.autoescape);
output += "\n                                    ";
;
}
else {
output += "\n                                        ";
output += runtime.suppressValue(env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"perNight")), env.opts.autoescape);
output += "\n                                    ";
;
}
output += "\n                                </div>\n                                <div class=\"search__result__price\">\n                                    ";
if(runtime.inOperator("instantBooking",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"features"))) {
output += "\n                                        ";
var t_48;
t_48 = (function() {
var output = "";
output += "\n                                            ";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 234, colno = 61, runtime.callWrap(runtime.memberLookup((t_13),"render"), "toolTip[\"render\"]", context, [{"id": "instant-booking-" + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"id"),"placement": "top","content": env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"instantBooking"))}]))), env.opts.autoescape);
output += "\n                                        ";
;
return output;
})()
;
frame.set("instantBookingTooltip", t_48, true);
if(frame.topLevel) {
context.setVariable("instantBookingTooltip", t_48);
}
if(frame.topLevel) {
context.addExport("instantBookingTooltip", t_48);
}
output += "\n                                        ";
output += runtime.suppressValue((lineno = 240, colno = 72, runtime.callWrap(runtime.memberLookup((t_7),"render"), "instantBookingTemplate[\"render\"]", context, [runtime.contextOrFrameLookup(context, frame, "instantBookingTooltip"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"id")])), env.opts.autoescape);
output += "\n                                    ";
;
}
output += "\n                                    <data class=\"search__result__day-price\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"dayPrice"), env.opts.autoescape);
output += "\">\n                                        ";
output += runtime.suppressValue(env.getFilter("format_currency").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"dayPrice"),"EUR"), env.opts.autoescape);
output += "\n                                    </data>\n                                    <div class=\"search__result__info\">\n                                        ";
var t_49;
t_49 = "extra-cost-template-" + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"id");
frame.set("template_id", t_49, true);
if(frame.topLevel) {
context.setVariable("template_id", t_49);
}
if(frame.topLevel) {
context.addExport("template_id", t_49);
}
output += "\n                                        ";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 247, colno = 79, runtime.callWrap(runtime.memberLookup((t_10),"render"), "cardHouseExtraCostsInfoButton[\"render\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"id"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"startDate"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"endDate")]))), env.opts.autoescape);
output += "\n                                    </div>\n                                </div>\n                            ";
;
}
output += "\n                        </div>\n                    ";
;
}
output += "\n                ";
;
}
output += "\n\n                <div class=\"card__content__cta\">\n                    <a\n                        data-role=\"open-house-detail\"\n                        href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"websiteUrl"), env.opts.autoescape);
output += "\"\n                        class=\"nh-button nh-button--primary\"\n                        target=\"_blank\"\n                        data-testid=\"house-card-cta-button\"\n                    >\n                        ";
output += runtime.suppressValue(env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"view")), env.opts.autoescape);
output += "\n                    </a>\n                </div>\n            </div>\n        </footer>\n    </div>\n</article>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["templates/components/organisms/card-house.html.njk"] , dependencies)